import { isEmpty } from "lodash";
import useQueryParams from "../../../hooks/useQueryParams";
import { SubscriptionCheckoutQueryString } from "../entities/subscription-checkout-query-string.enum";
import { UPGRADE_STATUS_SUCCEEDED } from "../payment-backdrop";

export function useIsBackFromSubscriptionCheckout(): boolean {
  const queryParams = useQueryParams();

  const currentState = queryParams?.get(SubscriptionCheckoutQueryString.STATE);
  const currentId = queryParams?.get(SubscriptionCheckoutQueryString.ID);

  const isSucceededStatus = currentState === UPGRADE_STATUS_SUCCEEDED;
  const isBackFromSubscriptionCheckout = isSucceededStatus && !isEmpty(currentId);

  return isBackFromSubscriptionCheckout;
}
